import React, { useState } from 'react';
import { Briefcase, MapPin, Code, BookOpen, Users, Podcast } from 'lucide-react';

const CareerPage = () => {
    const [activeJobCategory, setActiveJobCategory] = useState(null);
    const [activeRoadmap, setActiveRoadmap] = useState(null);

    const handleContactClick = () => {
        window.open('mailto:harshmarkandey2022@vitbhopal.ac.in', '_blank');
    };

    const openyt = () => {
        window.open('https://www.youtube.com/@healthotechclub/videos', '_blank');
    };

    const handleJobClick = (link) => {
        window.open(link, '_blank', 'noopener,noreferrer');
    };

    const jobCategories = [
        {
            title: "Tech Roles",
            icon: <Code size={24} />,
            roles: [
                {
                    title: "Software Engineer-Intern",
                    company: "Kognitos",
                    location: "Banglore",
                    link: "https://www.kognitos.com/careers/?ashby_jid=eb45a269-52b5-4160-8ff4-ab78bf594755#apply-now"
                },
                {
                    title: "Software Engineer-Intern",
                    company: "Zluri",
                    location: "Banglore",
                    link: "https://zluri.keka.com/careers/jobdetails/18096"
                },
                {
                    title: "Software Engineer-Intern",
                    company: "Naptha AI",
                    location: "Mumbai",
                    link: "https://naptha.ai/careers?ashby_jid=96df9dd3-85bc-4cff-b806-973b78bb433a"
                },
                {
                    title: "Software Engineer (Summer Internship)",
                    company: "Mercari",
                    location: "Tokyo, Japan",
                    link: "https://apply.workable.com/mercari/j/29F7FC9266/"
                }

                
                // ... other roles remain the same
            ]
        },
        // ... other job categories remain the same
    ];

    const careerRoadmaps = [
        {
            title: "Software Development",
            icon: <Code size={24} />,
            stages: [
                "Back-End Developer",
                "Front-End Developer",
                "QA Developer",
                "Game Developer",
                "Data Analyst"
            ],
            links: [
                "https://roadmap.sh/backend",
                "https://roadmap.sh/frontend",
                "https://roadmap.sh/qa",
                "https://roadmap.sh/game-developer",
                "https://roadmap.sh/data-analyst"
            ]
        },
        // ... other roadmaps
    ];

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-900 via-purple-900 to-indigo-900 flex flex-col items-center justify-center p-4 md:p-20 space-y-8">
            {/* Existing Jobs and Roadmaps Section */}
            <div className="bg-white/20 backdrop-blur-lg border border-white/30 rounded-3xl shadow-2xl w-full max-w-6xl flex flex-col md:flex-row overflow-hidden mt-8">
                {/* Jobs Section */}
                <div className="w-full md:w-1/2 p-6 md:p-12 border-r border-white/20">
                    <h2 className="text-3xl font-bold mb-8 text-white flex items-center mt-5 md:mt-0">
                        <Briefcase className="mr-4" /> Job Listings
                    </h2>

                    <div className="space-y-4">
                        {jobCategories.map((category, index) => (
                            <div
                                key={index}
                                className={`bg-white/10 rounded-2xl p-4 cursor-pointer transition-all duration-300 ${
                                    activeJobCategory === index ? 'ring-2 ring-white/30' : 'hover:bg-white/20'
                                }`}
                                onClick={() => setActiveJobCategory(index === activeJobCategory ? null : index)}
                            >
                                <div className="flex justify-between items-center">
                                    <div className="flex items-center space-x-3">
                                        {category.icon}
                                        <span className="text-xl text-white">{category.title}</span>
                                    </div>
                                    <span className="text-white/70">{category.roles.length} Roles</span>
                                </div>

                                {activeJobCategory === index && (
                                    <div className="mt-4 space-y-3">
                                        {category.roles.map((role, roleIndex) => (
                                            <div
                                                key={roleIndex}
                                                className="bg-white/10 p-3 rounded-xl hover:bg-white/20 transition-colors"
                                               onClick={(e) => {
                                                e.stopPropagation();
                                                handleJobClick(role.link);
                                            }}>
                                                <div className="flex justify-between items-center">
                                                    <div>
                                                        <h3 className="text-white font-semibold">{role.title}</h3>
                                                        <p className="text-white/70 text-sm">{role.company}</p>
                                                    </div>
                                                    <div className="flex items-center text-white/70">
                                                        <MapPin size={16} className="mr-2" />
                                                        <span>{role.location}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                {/* Career Roadmaps Section */}
                <div className="w-full md:w-1/2 p-6 md:p-12">
                    <h2 className="text-3xl font-bold mb-8 text-white flex items-center">
                        <BookOpen className="mr-4" /> Career Roadmaps
                    </h2>

                    <div className="space-y-4">
                        {careerRoadmaps.map((roadmap, index) => (
                            <div
                                key={index}
                                className={`bg-white/10 rounded-2xl p-4 cursor-pointer transition-all duration-300 ${
                                    activeRoadmap === index ? 'ring-2 ring-white/30' : 'hover:bg-white/20'
                                }`}
                                onClick={() => setActiveRoadmap(index === activeRoadmap ? null : index)}
                            >
                                <div className="flex justify-between items-center">
                                    <div className="flex items-center space-x-3">
                                        {roadmap.icon}
                                        <span className="text-xl text-white">{roadmap.title}</span>
                                    </div>
                                </div>

                                {activeRoadmap === index && (
                                    <div className="mt-4 space-y-3">
                                        {roadmap.stages.map((stage, stageIndex) => (
                                            <div
                                                key={stageIndex}
                                                className="bg-white/10 p-3 rounded-xl hover:bg-white/20 transition-colors relative"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    if (roadmap.links && roadmap.links[stageIndex]) {
                                                        window.open(roadmap.links[stageIndex], '_blank', 'noopener,noreferrer');
                                                    }
                                                }}
                                            >
                                                <div className="absolute left-0 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-3 h-3 bg-white/50 rounded-full"></div>
                                                <span className="text-white pl-4">{stage}</span>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Community Contribution Section */}
            <div className="bg-white/20 backdrop-blur-lg border border-white/30 rounded-3xl shadow-2xl w-full max-w-6xl p-6 md:p-12">
                <div className="flex items-center mb-6">
                    <Users className="mr-4 text-white" size={32} />
                    <h2 className="text-3xl font-bold text-white">Community Contribution</h2>
                </div>
                <div className="text-white/80 space-y-4">
                    <p>
                        We've curated a list of job openings to help professionals find their next opportunity.
                        If you know about exciting job opportunities not listed here, we invite you to contribute
                        to our community in the spirit of collaboration and support.
                    </p>
                    <p>
                        Your insights can help fellow professionals discover hidden gems in the job market.
                        Together, we can create a more connected and supportive professional network.
                    </p>
                    <button
                        onClick={handleContactClick}
                        className="bg-white/20 hover:bg-white/30 text-white font-bold py-3 px-6 rounded-xl transition-colors"
                    >
                        Contribute Job Listing
                    </button>
                </div>
            </div>

            {/* Podcast Section */}
            <div className="bg-white/20 backdrop-blur-lg border border-white/30 rounded-3xl shadow-2xl w-full max-w-6xl p-6 md:p-12">
                <div className="flex items-center mb-6">
                    <Podcast className="mr-4 text-white" size={32} />
                    <h2 className="text-3xl font-bold text-white">Industry Insights Podcast</h2>
                </div>
                <div className="flex flex-col md:flex-row items-center space-y-4 md:space-y-0 md:space-x-8">
                    <div className="w-full md:w-1/2 text-white/80 space-y-4">
                        <p>
                            Dive deep into industry trends with our podcast featuring conversations
                            with key leaders, innovators, and experts across various professional domains.
                        </p>
                        <p>
                            Get insights, strategies, and unique perspectives that can shape your
                            career and understanding of the professional landscape.
                        </p>
                        <button
                            onClick={openyt}
                            className="bg-white/20 hover:bg-white/30 text-white font-bold py-3 px-6 rounded-xl transition-colors"
                        >
                            View All Episodes
                        </button>
                    </div>
                    <div className="w-full md:w-1/2 ">
                        <div className="aspect-video bg-white/10 flex items-center justify-center rounded-xl overflow-hidden">
                            <iframe
                                width="100%"
                                height="100%"
                                src="https://www.youtube.com/embed/hz6J0RxjS8Q?si=E4aY9syIpqXfmDq0"
                                title="Latest Podcast Episode"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CareerPage;